import styled from 'styled-components';

export const InlineErrorMessage = styled.div.attrs({
  'aria-live': 'polite',
})`
  color: ${({ theme }) => theme.palette.error.main};
  padding: 6px;
`;
